import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import InlineSVG from 'svg-inline-react';

import { getIcons } from '../../utils/iconUtils';
import { isSSR } from '../../helpers/ssr';

import type { IIcon } from './types';

const icons = getIcons();
export const iconsName = Object.keys(icons);

/**
 * @deprecated
 * Вместо Icon использовать react-icons из lt-components
 */
const Icon: FC<IIcon> = ({
  type = 'logo',
  className,
  width,
  height,
  fill,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isMobile, // чтобы дальше не прокидывался
  // TODO: убрать spread и проверить, чтобы никто не юзал его
  ...props
}) => {
  const isIconExist = iconsName.find((a) => a === type);
  if (!isIconExist) {
    return null;
  }

  return (
    <i
      className={cn('lt-icons', `lt-icons__${type}`, className)}
      style={{ width, height }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <InlineSVG style={{ fill }} src={icons[type]} raw={!isSSR} />
    </i>
  );
};

export default Icon;
